import { useGamification } from '../../providers/GamificationProvider';
import { useAuth } from '@presov.sk/presov-auth-react';
import {
  Avatar,
  Box,
  CircularProgress,
  Stack,
} from '@presov.sk/presov-ui-react';
import React from 'react';

/**
 * Koliesko používateľa s **prstencom úrovne** - už len pre profil.
 *
 * V hlavičke ho vystriedal [[HeaderUser]] s `UserMenu` z knižnice, takže z tohto
 * komponentu zostalo to, čo profil naozaj kreslí: veľké koliesko na tmavom
 * podklade a prstenec postupu k ďalšej úrovni. Menu, body pod kolieskom aj
 * varianty veľkosti a témy odišli s hlavičkou - boli to jediné miesta, kde sa
 * používali.
 *
 * Prstence sú dva `CircularProgress` na sebe: spodný je koľaj (plných 100 %),
 * horný postup. Bez úrovne sú oba priehľadné, takže koliesko zostane samotné.
 */
const UserAvatar: React.FC = () => {
  const { authUser } = useAuth();
  const { generalAccountPoints, gamificationTier } = useGamification();

  return (
    <Stack direction={'column'} alignItems={'center'} spacing={0}>
      <Box
        position='relative'
        display={'flex'}
        alignItems={'center'}
        justifyContent={'center'}
      >
        <CircularProgress
          variant='determinate'
          value={100}
          sx={{
            color: gamificationTier?.title ? '#fff' : 'transparent',
          }}
          size={56}
          thickness={8}
        />
        <Box
          position='absolute'
          top={0}
          left={0}
          bottom={0}
          right={0}
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <CircularProgress
            variant='determinate'
            value={
              ((generalAccountPoints %
                (gamificationTier?.max_points - generalAccountPoints)) /
                (gamificationTier?.max_points - generalAccountPoints)) *
              100
            }
            thickness={4}
            sx={{
              color: gamificationTier?.title ? 'primary.main' : 'transparent',
              rotate: '-180deg',
            }}
            size={56}
          />
        </Box>
        <Box
          position='absolute'
          top={0}
          left={0}
          bottom={0}
          right={0}
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <Avatar
            sx={{
              border: 'solid',
              borderColor: 'transparent',
              borderWidth: 1,
              width: 48,
              height: 48,
              fontSize: 16,
              mb: 0.12,
            }}
          >
            {[authUser?.name?.[0], authUser?.surname?.[0]]
              .filter(Boolean)
              .join('')}
          </Avatar>
        </Box>
      </Box>
    </Stack>
  );
};

export default UserAvatar;
